var AWSDataHomeContentServiceModule = /** @class */ (function () {
    function AWSDataHomeContentServiceModule() {
    }
    return AWSDataHomeContentServiceModule;
}());
export { AWSDataHomeContentServiceModule };
